/* US-only UpCart copy and secondary notice styling, including shadow DOM. */
(function () {
  var OLD_TEXT = /All US import duties and taxes are covered by us\s*[—–-]\s*nothing to pay on delivery\.?/i;
  var NEW_TEXT = 'Duties & taxes included – nothing to pay on delivery.';
  var STYLE_ID = 'kr-us-cart-content-style';

  function replaceMessage(root) {
    var isUS = !!window.Shopify && window.Shopify.country === 'US';
    var style = root.querySelector('#' + STYLE_ID);
    var css = '#upcart-us-content{display:none!important;}';
    if (isUS) {
      css = '#upcart-us-content{display:flex!important;box-sizing:border-box!important;'
        + 'background:#f7f7f7!important;color:#444!important;border:1px solid #e8e8e8!important;'
        + 'border-radius:8px!important;padding:10px 12px!important;text-align:left!important;'
        + 'justify-content:flex-start!important;font-family:inherit!important;'
        + 'font-size:13px!important;font-weight:400!important;line-height:1.5!important;'
        + 'letter-spacing:normal!important;box-shadow:none!important;}'
        + '#upcart-us-content *{color:inherit!important;font-family:inherit!important;'
        + 'font-size:inherit!important;font-weight:inherit!important;line-height:inherit!important;'
        + 'text-align:left!important;}';
    }
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = css;
      root.appendChild(style);
    } else if (style.textContent !== css) {
      style.textContent = css;
    }

    var el = root.querySelector('#upcart-us-content');
    if (el && isUS) {
      // The app supplies an inline !important pink background.
      el.style.setProperty('background-color', '#f7f7f7', 'important');
      replaceText(el, OLD_TEXT, NEW_TEXT);
    }
    if (isUS) {
      root.querySelectorAll('.upcart-public-announcement').forEach(function (announcement) {
        replaceText(announcement, /((?:mystery\s+)?gift\s+worth\s*)\$59\b/gi, '$1$45 USD');
      });
    }
  }

  function replaceText(el, pattern, replacement) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var updated = node.nodeValue.replace(pattern, replacement);
      if (updated !== node.nodeValue) node.nodeValue = updated;
    }
  }

  function attach() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (!root) return false;
    replaceMessage(root);
    new MutationObserver(function () {
      replaceMessage(root);
    }).observe(root, { childList: true, subtree: true, characterData: true });
    return true;
  }

  if (!attach()) {
    var timer = setInterval(function () {
      if (attach()) clearInterval(timer);
    }, 300);
    setTimeout(function () {
      clearInterval(timer);
    }, 30000);
  }
})();
